import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { API_URL } from '../config/api';

const SubscribeSuccessPage = () => {
  const [status, setStatus] = useState('checking');
  const [paymentInfo, setPaymentInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');
    
    if (!sessionId) {
      if (isMounted) setStatus('error');
      return;
    }

    const checkStatus = async (attempts = 0) => {
      if (!isMounted) return;
      
      if (attempts >= 5) {
        if (isMounted) setStatus('timeout');
        return;
      }

      try {
        const res = await axios.get(`${API_URL}/v1/subscription/status/${sessionId}`);
        if (!isMounted) return;
        
        setPaymentInfo(res.data);
        
        if (res.data.payment_status === 'paid') {
          setStatus('success');
        } else if (res.data.status === 'expired') {
          setStatus('expired');
        } else {
          setTimeout(() => checkStatus(attempts + 1), 2000);
        }
      } catch (err) {
        if (isMounted) setStatus('error');
      }
    };

    checkStatus();
    
    return () => { isMounted = false; };
  }, []);

  return (
    <>
      <Header />
      <main className="main page-content">
        <div className="success-page">
          {status === 'checking' && (
            <>
              <div className="success-icon loading">⏳</div>
              <h1>Processing payment...</h1>
              <p>Please wait while we confirm your subscription.</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <div className="success-icon">✓</div>
              <h1>Welcome to Framecast Pro!</h1>
              <p>Your subscription is now active. You'll receive your first daily digest tomorrow morning.</p>
              {paymentInfo && (
                <div className="payment-details">
                  <p><strong>Plan:</strong> {paymentInfo.plan}</p>
                  <p><strong>Email:</strong> {paymentInfo.email}</p>
                </div>
              )}
              <button className="action-btn primary" onClick={() => navigate('/')}>
                Start Exploring
              </button>
            </>
          )}
          
          {status === 'error' && (
            <>
              <div className="success-icon error">✗</div>
              <h1>Something went wrong</h1>
              <p>We couldn't verify your payment. Please contact support.</p>
              <button className="action-btn" onClick={() => navigate('/subscribe')}>
                Try Again
              </button>
            </>
          )}
          
          {status === 'expired' && (
            <>
              <div className="success-icon error">⏱</div>
              <h1>Session Expired</h1>
              <p>Your checkout session has expired. Please try again.</p>
              <button className="action-btn primary" onClick={() => navigate('/subscribe')}>
                Subscribe Again
              </button>
            </>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default SubscribeSuccessPage;
